module.exports = __webpack_public_path__ + "img/03cf481.png";